import { render, staticRenderFns } from "./_course.vue?vue&type=template&id=1b852bf1&scoped=true&"
import script from "./_course.vue?vue&type=script&lang=js&"
export * from "./_course.vue?vue&type=script&lang=js&"
import style0 from "./_course.vue?vue&type=style&index=0&id=1b852bf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b852bf1",
  null
  
)

export default component.exports